module.exports = __webpack_public_path__ + "static/salsaverdecube-48b5a9019811223e6f041ea458d9cf55.jpg";